import { render, staticRenderFns } from "./DashboardPlugin.vue?vue&type=template&id=ad27f776&scoped=true&"
import script from "./DashboardPlugin.vue?vue&type=script&lang=js&"
export * from "./DashboardPlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad27f776",
  null
  
)

export default component.exports